import React from 'react';
import PropTypes from 'prop-types';
import { routes as originRoutes } from '../../configs/routes';
import { SessionContext, ActionContext, RouterContext } from './MainContainer';
import ParentContainerRoute from './ParentContainerRoute';
import { connect } from 'react-redux';
import StorageHelper from '../../utils/StorageHelper';
import { STORAGE_KEYS } from '../../configs/AppConfig';
import { Redirect } from 'react-router-dom';
import DefaultLayout from './DefaultLayout';
import { getCachedRoutePath } from '../../state/route/routeSelector';

const PublicRoute = props => {
  const {
    routes,
    actions: {
      sessionActions: { cacheRoutePath }
    },
    location
  } = props;
  let basePath = '/';
  if (location.pathname.includes('preview')) {
    basePath = '/preview';
  }
  const customRoutes = routes.filter(el => el.layoutId.startsWith(originRoutes.publicRoutes.name, 0));
  let isAgree = StorageHelper.getSessionItem(STORAGE_KEYS.disclosureAgreement);
  let type = 'disclosure';
  if (location.pathname && location.pathname.includes('patient')) {
    isAgree = StorageHelper.getSessionItem(STORAGE_KEYS.patientAgreement);
    type = 'patient';
  }
  if (!isAgree && location.pathname.includes(type)) {
    cacheRoutePath();
    return <Redirect to={{ pathname: basePath, search: `?type=${type}` }} push/>;
  }
  if (location.pathname.includes('viewer')) {
    return (
      <ParentContainerRoute routes={customRoutes} />
    );
  }
  return (
    <DefaultLayout useAppBar={location.pathname.includes('faq')}>
      <ParentContainerRoute routes={customRoutes} />
    </DefaultLayout>
  );
};

PublicRoute.propTypes = {
  routes: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  location: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
  };
};

export default connect(mapStateToProps)(props => (
  <RouterContext.Consumer>
    {({ location }) => (
      <ActionContext.Consumer>
        {actions => (
          <SessionContext.Consumer>
            {() => <PublicRoute {...props} actions={actions} location={location}/>}
          </SessionContext.Consumer>
        )}
      </ActionContext.Consumer>
    )}
  </RouterContext.Consumer>
));
